import { generateSlug } from '@/utils/string'

export const getIcon = name => {
  return `https://storage.googleapis.com/contzilla/${generateSlug(name)}.svg`
}
